import React from "react";
import { useTranslation } from "react-i18next";
import ClaimInfoTable from "./ClaimInfoTable";
import AppOutlineButton from "components/ui/AppOutlineButton";

const ClaimInfo = (props) => {
  let { jeeblyOrder } = props;
  const { t } = useTranslation();

  return (
    <div>
      <div className="flex justify-center">
        <AppOutlineButton
          variant="secondary"
          size="lg"
          onClick={props.getjeeblyOrderStatus}
        >
          {t("Refresh for latest info")}
        </AppOutlineButton>
      </div>
      <ClaimInfoTable {...{ jeeblyOrder }} />
    </div>
  );
};

export default ClaimInfo;
